import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue';
import Footer from '@/components/Footer.vue';
import { Tenant } from '../store/models';
import tenantModule from '@/store/modules/tenantModule';

import {  ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';



export default /*#__PURE__*/_defineComponent({
  __name: 'DisclaimerLayout',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const tenant = ref<Tenant | null>(null);
const imprintUrl = ref<string | null>(null);

  onMounted(async () => {
    loadTenantInfo();
  });

 async function loadTenantInfo() {
  try {
        tenant.value = tenantModule.tenantInfo || null;
        if (!tenant.value) {
          await tenantModule.loadTenantInfo();
          tenant.value = tenantModule.tenantInfo;
          imprintUrl.value = tenant.value?.imprintUrl || null;
        }

        if (route.query.imprint) {
          imprintUrl.value = route.query.imprint as string;
        }
      } catch (error) {
        console.error(error);
      }

      if (!tenant.value) {
        router.push({ name: 'invalidtenant' });
      }
    }

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "hhh lpr fff",
    class: "shadow-3"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(Footer, { imprintUrl: imprintUrl.value }, null, 8, ["imprintUrl"])
    ]),
    _: 1
  }))
}
}

})